import { useQueryClient } from '@tanstack/react-query';
import { GET_ALL_CHALLENGES_KEY } from '_api/queries/challenge/useGetAllChallenges';
import { GET_ALL_PATIENT_CHALLENGES_BY_ID_KEY } from '_api/queries/challenge/useGetAllPatientChallengesByID';

import useApiMutation from '../useApiMutation';

export const DELETE_PATIENT_CHALLENGE_SETTING = 'delete-patient-challenge-setting';

export const useDeletePatientChallengeSetting = () => {
  const queryClient = useQueryClient();
  return useApiMutation<{}, { id: number }>(
    ({ id }) => `/challenge/patient-challenge-setting/${id}`,
    'delete',
    {},
    {
      mutationKey: [DELETE_PATIENT_CHALLENGE_SETTING],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ALL_CHALLENGES_KEY] });
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_PATIENT_CHALLENGES_BY_ID_KEY],
        });
      },
    },
  );
};
